import { Radio } from "antd";
import styled from "styled-components";
import { theme } from "../../../theme";

const CustomRadio = styled(Radio)``;

/**
 * readOnly용 작업
 */
const { Group } = CustomRadio;
const CustomRadioGroup = styled(Group)`
  &.ant-radio-group {
    & .ant-radio-wrapper-disabled {
      & span:not([class]) {
        color: ${theme.colors.gray1};
      }
    }
  }
`;

export { CustomRadio, CustomRadioGroup };
